import { ApiUrl } from './common/Config';
import { get } from './common/Helper';

const baseUrl = ApiUrl + 'booksectionsourcetype/';

export const getAllBookSectionSourceTypes = async(token) => {
    let url = baseUrl + 'all';
    return await get(url, token);
};